var mcb = mcb || {};

mcb.listgroupitem = mcb.listgroupitem || new (function () {

    this.init = function () {
        const listGroupItem = document.querySelectorAll(".list-group-item");

        if (listGroupItem) {

            listGroupItem.forEach(element => {
                element.addEventListener("click", e => {

                    const ignoreList = [
                        "btn-catalog",
                        "btn-favorite",
                        "btn-remove",
                        "accordion"
                    ];

                    if (ignoreList.some(c => e.target.className.includes(c)))
                        return;

                    e.preventDefault();

                    const btn = e.target.closest(".list-group-item").querySelector(".list-group-item__button");

                    if (btn) {
                        const href = btn.getAttribute("href");
                        window.location.href = href;
                    }
                });
            });
        }
    };
})();